import { Map } from 'immutable';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';
import atomicBlock from '@studionand/ada-next/src/legacy/atomicBlock';
import useStores from '../../../utils/useStores';

const useStyles = makeStyles(theme => ({
  dropdown: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginBottom: theme.spacing(1),
  },
  link: {
    ...theme.typography.body2,
    marginBottom: theme.spacing(1),
    '&:hover': {
      color: theme.editorPalette.primary.light,
    },
  },
}));

const DropDown = props => {
  const classes = useStyles();
  return <div className={classes.dropdown} {...props} />;
};

const AddToCalendarDropdown = AddToCalendarHOC(Button, DropDown);

const createCalendarEvent = page => {
  const startTime = moment(page.data.startDate).startOf('day');
  const endTime = moment(page.data.endDate || page.data.startDate).endOf('day');
  const duration = moment.duration(endTime.diff(startTime)).asHours();
  return {
    title: page.title,
    description: page.data.abstract,
    location: page.data.place,
    endDatetime: startTime.utc().format('YYYYMMDDTHHmmssZ'),
    startDatetime: endTime.utc().format('YYYYMMDDTHHmmssZ'),
    duration,
  };
};

const AddToCalendarSection = atomicBlock({ alignment: false })(props => {
  const {
    blockProps: { page },
  } = props;
  const { uiStore } = useStores();
  const classes = useStyles();
  const hasDate = !!page.data.startDate;
  const event = createCalendarEvent(page);
  return (
    <Box mb={8} pt={8}>
      {!hasDate && (
        <Typography variant="body2" align="center">
          Auf dieser Seite wurde kein Kalendareintrag gefunden.
        </Typography>
      )}
      {hasDate && (
        <Box textAlign="center">
          <AddToCalendarDropdown
            buttonText="Zum Kalendar hinzufügen"
            event={event}
            linkProps={{
              className: classes.link,
            }}
          />
        </Box>
      )}
    </Box>
  );
});

const plugin = () => ({
  blockRendererFn: (block, { getProps }) => {
    const { page, readOnly } = getProps();
    const type = block.getType();
    if (type === 'add-to-calendar') {
      return {
        component: AddToCalendarSection,
        editable: false,
        props: {
          page,
          readOnly,
        },
      };
    }
    return null;
  },
  // blockStyleFn: (block, { getProps }) => {
  //   const { page, readOnly } = getProps();
  //   const type = block.getType();
  //   const data = block.getData();
  //   const alignment = data.alignment;
  //   return cx(
  //     // default overwrites
  //     style[page.type],
  //     style[alignment],
  //     { [style.addToCalendar]: type === 'add-to-calendar' },
  //   );
  // },
  blockRenderMap: Map({
    'add-to-calendar': {
      element: 'div',
      props: {},
      isBlockTypeMutable: false,
      fixed: false,
    },
  }),
});

export default plugin;
